export default "__VITE_ASSET__BOh4EcmN__"